import React from 'react'

import { LayoutLogin } from 'src/apps/aria/components/layout/Login'
import { IRouteData } from 'src/core/routes/types'

export const CustomRoutes: IRouteData[] = [
  {
    path: '/',
    element: <LayoutLogin />,
    access: 'Guest',
  },
]
